// Die Zugangsdaten der angemeldeten Sitzung.
//
// Basic Auth: Benutzername und Kennwort gehen bei jedem Aufruf als Header mit.
// Kein Cookie, keine Sitzungsverwaltung im Server — bei einer Anwendung mit
// drei Benutzern waere das Aufwand ohne Gewinn.
//
// `sessionStorage` und nicht `localStorage`: Die Anmeldung endet mit dem
// Schliessen des Tabs. Im localStorage laege sie unbegrenzt und ueberdauerte
// jeden, der den Rechner danach benutzt.

const KEY = 'iw.auth'
const USER = 'iw.user'

export function saveAuth(user: string, password: string): void {
  sessionStorage.setItem(KEY, btoa(`${user}:${password}`))
  // Der Name steht getrennt daneben, damit die Oberflaeche ihn anzeigen kann,
  // ohne die Zugangsdaten wieder auseinanderzunehmen.
  sessionStorage.setItem(USER, user)
}

export function clearAuth(): void {
  sessionStorage.removeItem(KEY)
  sessionStorage.removeItem(USER)
}

export function hasAuth(): boolean {
  return sessionStorage.getItem(KEY) !== null
}

export function currentUser(): string | null {
  return sessionStorage.getItem(USER)
}

/**
 * Der Wert für den `Authorization`-Header, oder null.
 *
 * Der Aufrufer setzt den Header selbst — hier steht nur, was drin steht. Damit
 * bleibt diese Datei ohne Kenntnis von Endpunkten und ohne fetch.
 */
export function authHeader(): string | null {
  const token = sessionStorage.getItem(KEY)
  return token ? `Basic ${token}` : null
}
